export function getLogoAsset(logoType: 'Black' | 'White' | 'Black2' | 'White2'): string {
  try {
    const svg = require(`../common/assets/images/logo${logoType}.svg`);
    return svg.default || svg;
  } catch (e) {
    const png = require(`../common/assets/images/logo${logoType}.png`);
    return png.default || png;
  }
}
